import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Metas from 'components/Metas';
import PageContainer from "components/Page";
import { ecommerce, pages } from 'config/constants';
import CartService from 'services/Cart';
import PrivatePath from 'components/PrivatePath';
import {token} from 'config/new';
import style from './style.scss';//NOSONAR

const HomeQA = (props) => {
    useEffect(() => {
        if(props.location){
            CartService.addProductsByUrl(props.location.search, props.history.replace);
        }
    }, []);

    return (
        <div className="home-page page">
            <Metas>
                <title>Supermercado | {ecommerce.metaTitle}</title>
            </Metas>
            <PageContainer pageId={pages.homeQA} />
        </div>
    )
}

HomeQA.propTypes = {
    location: PropTypes.object
};

HomeQA.token =  token.homeQA

export default PrivatePath(HomeQA);
